import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../lib/api-client";
import { queryKeys } from "../query-keys";
import {
  InterviewListResponseSchema,
  InterviewSchema,
} from "@applicant-reviewer/api";

export function useInterviews() {
  return useQuery({
    queryKey: queryKeys.interviews.list(),
    queryFn: () => apiClient.get("/interviews", InterviewListResponseSchema),
  });
}

export function useInterview(id: string) {
  return useQuery({
    queryKey: queryKeys.interviews.detail(id),
    queryFn: () => apiClient.get(`/interviews/${id}`, InterviewSchema),
    enabled: Boolean(id),
  });
}
